export default {"src":"/_next/static/media/help-circle.dd7fea6c.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};